import Vue from 'vue'
import VueRouter from 'vue-router'
import willCheck from '../views/pages/will-check/will-check'
import Home from '../views/pages/home/home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    /* eslint-disable */
    component: Home
  },
  {
    path: '/home',
    name: 'home',
    /* eslint-disable */
    component: Home
  },
  {
    path: '/will-check',
    name: 'will-check',
    component: willCheck,
    meta: {
      title: '实名认证'
    }
  },
  {
    path: '/huoti',
    name: 'huoti',
    component: resolve => require(['@/views/pages/huoti'], resolve),
    meta: {
      title: '活体检测'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // 设置标题
    document.title = to.meta.title
  }
  next()
})
router.afterEach((to, from, next) => {
  next()
})

export default router
